"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7028],{

/***/ 67028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vD": function() { return /* reexport */ Products_InfoBox; },
  "k7": function() { return /* reexport */ Products_ProductFilter; },
  "Li": function() { return /* reexport */ ProductGallery; },
  "Cd": function() { return /* reexport */ Products_ProductItem; },
  "RC": function() { return /* reexport */ Products_ProductItemTabs; },
  "tn": function() { return /* reexport */ Products_ProductTypeRead; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./styles/jss/ProductsPage.styles.js
var ProductsPage_styles = __webpack_require__(25673);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 32 modules
var esm = __webpack_require__(51813);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./styles/jss/Inputs.styles.js + 25 modules
var Inputs_styles = __webpack_require__(45248);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./components/Loader.jsx + 1 modules
var Loader = __webpack_require__(85232);
// EXTERNAL MODULE: ./services/products.api.js
var products_api = __webpack_require__(10625);
;// CONCATENATED MODULE: ./components/PagesComponents/Products/ProductFilter.jsx









var ProductFilter = function(param) {
    var applications = param.applications, markets = param.markets, methods = param.methods, types = param.types, setType = param.setType, type = param.type, setApplication = param.setApplication, application = param.application, setMarket = param.setMarket, market = param.market, setMethod = param.setMethod, method = param.method;
    var t = (0,esm/* useTranslation */.$G)([
        "products"
    ]).t;
    var ref = (0,router.useRouter)(), locale = ref.locale, push = ref.push;
    var handleChange = function(evt, setFilter, filterType) {
        setFilter(evt.target.value);
        if (filterType === "type" && evt.target.value !== "all") {
            var getTypeName = types.data.filter(function(item) {
                return item.id === evt.target.value;
            });
            var url = "?type=".concat(getTypeName[0].attributes.name.toString().toLowerCase());
            push(url, url, {
                shallow: true,
                locale: locale
            });
            return;
        }
        if (filterType === "type" && evt.target.value === "all") {
            var url1 = "products";
            push(url1, url1, {
                shallow: true,
                locale: locale
            });
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductsPage_styles/* Filter */.wn, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsPage_styles/* FilterItem */.L2, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inputs_styles/* CustomTextField */.y, {
                    select: true,
                    fullWidth: true,
                    size: "small",
                    label: t("p-type"),
                    value: type,
                    onChange: function(evt) {
                        return handleChange(evt, setType, "type");
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
                            value: "all",
                            children: "All"
                        }),
                        types === null || types === void 0 ? void 0 : types.data.map(function(item) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
                                value: item.id,
                                children: item.attributes.name.toString()
                            }, item.id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                orientation: "vertical",
                flexItem: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsPage_styles/* FilterItem */.L2, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inputs_styles/* CustomTextField */.y, {
                    select: true,
                    fullWidth: true,
                    size: "small",
                    variant: "outlined",
                    label: t("p-application"),
                    value: application,
                    onChange: function(evt) {
                        return handleChange(evt, setApplication, "application");
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
                            value: "all",
                            children: "All"
                        }),
                        applications === null || applications === void 0 ? void 0 : applications.data.map(function(item) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
                                value: item.id,
                                children: item.attributes.application.toString()
                            }, item.id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                orientation: "vertical",
                flexItem: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsPage_styles/* FilterItem */.L2, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inputs_styles/* CustomTextField */.y, {
                    select: true,
                    fullWidth: true,
                    size: "small",
                    variant: "outlined",
                    label: t("p-market"),
                    value: market,
                    onChange: function(evt) {
                        return handleChange(evt, setMarket, "market");
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
                            value: "all",
                            children: "All"
                        }),
                        markets === null || markets === void 0 ? void 0 : markets.data.map(function(item) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
                                value: item.id,
                                children: item.attributes.market.toString()
                            }, item.id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                orientation: "vertical",
                flexItem: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsPage_styles/* FilterItem */.L2, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inputs_styles/* CustomTextField */.y, {
                    select: true,
                    fullWidth: true,
                    size: "small",
                    variant: "outlined",
                    label: t("p-method"),
                    value: method,
                    onChange: function(evt) {
                        return handleChange(evt, setMethod, "method");
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
                            value: "all",
                            children: "All"
                        }),
                        methods === null || methods === void 0 ? void 0 : methods.data.map(function(item) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
                                value: item.id,
                                children: item.attributes.method.toString()
                            }, item.id);
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Products_ProductFilter = (ProductFilter);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./styles/jss/Layout.styles.js
var Layout_styles = __webpack_require__(48231);
// EXTERNAL MODULE: ./components/NextImage.jsx
var NextImage = __webpack_require__(68164);
// EXTERNAL MODULE: ./utils/helperFunction.js
var helperFunction = __webpack_require__(18991);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
;// CONCATENATED MODULE: ./components/PagesComponents/Products/ProductItem.jsx









var ProductItem = function(param) {
    var id = param.id, attributes = param.attributes;
    var ref;
    var t = (0,esm/* useTranslation */.$G)([
        "products"
    ]).t;
    var locale = (0,router.useRouter)().locale;
    var images = attributes.images, name = attributes.name, slug = attributes.slug, density = attributes.density, mfi = attributes.mfi, applications = attributes.applications, type = attributes.type;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/products/".concat(type.data.attributes.name.toString().toLowerCase().split(" ").join("-"), "/").concat(slug),
        locale: locale,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsPage_styles/* ProductsItem */.E_, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
                    container: true,
                    rowSpacing: {
                        xs: 2
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 3,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductsPage_styles/* Column */.sg, {
                                className: "typeColumn",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout_styles/* StandardImageWrapper */.JX, {
                                        className: "imageWrapper",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextImage/* default */.Z, {
                                            src: (ref = (0,helperFunction/* getImageUrl */.Jn)(images.data[0].attributes.formats, "thumbnail")) === null || ref === void 0 ? void 0 : ref.url,
                                            layout: "fill",
                                            objectFit: "cover",
                                            placeholder: "blur",
                                            alt: name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductsPage_styles/* Column */.sg, {
                                        locale: locale,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                                                className: "title",
                                                children: t("type")
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                className: "text",
                                                children: name
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 2,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductsPage_styles/* Column */.sg, {
                                locale: locale,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                                        className: "title",
                                        children: t("mfi")
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        className: "text",
                                        children: mfi
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 2,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductsPage_styles/* Column */.sg, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                                        className: "title",
                                        children: t("density")
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        className: "text",
                                        children: density
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 5,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductsPage_styles/* Column */.sg, {
                                locale: locale,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                                        className: "title",
                                        children: t("application")
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        className: "text app",
                                        children: applications === null || applications === void 0 ? void 0 : applications.data.map(function(item) {
                                            return item.attributes.application;
                                        }).join(", ")
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Products_ProductItem = (ProductItem);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(22546);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(44988);
// EXTERNAL MODULE: ./components/index.jsx + 10 modules
var components = __webpack_require__(11232);
;// CONCATENATED MODULE: ./components/PagesComponents/Products/ProductGallery.jsx






function ProductGallery(param) {
    var name = param.name, matches = param.matches, images = param.images;
    var ref = (0,react.useState)(null), thumbsSwiper = ref[0], setThumbsSwiper = ref[1];
    var ref1 = (0,react.useState)([]), data = ref1[0], setData = ref1[1];
    (0,react.useEffect)(function() {
        setData(images.map(function(item) {
            var ref;
            return {
                url: (ref = (0,helperFunction/* getImageUrl */.Jn)(item.attributes.formats, "medium")) === null || ref === void 0 ? void 0 : ref.url,
                alt: item.attributes.caption
            };
        }));
    }, [
        images
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            !matches && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* ProductBrodCramp */.aq, {
                name: name
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(swiper_react/* Swiper */.tq, {
                style: {
                    "--swiper-navigation-color": "#fff",
                    "--swiper-pagination-color": "#fff"
                },
                loop: true,
                spaceBetween: 10,
                navigation: true,
                thumbs: {
                    swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
                },
                modules: [
                    swiper_esm/* FreeMode */.Rv,
                    swiper_esm/* Navigation */.W_,
                    swiper_esm/* Thumbs */.o3
                ],
                className: "view-selected-image-swiper ",
                children: data.map(function(img) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* NextImage */.oH, {
                            src: img.url,
                            alt: img.alt,
                            layout: "fill",
                            placeholder: "blur"
                        })
                    }, img.alt);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(swiper_react/* Swiper */.tq, {
                onSwiper: setThumbsSwiper,
                spaceBetween: 10,
                slidesPerView: 4,
                freeMode: true,
                watchSlidesProgress: true,
                modules: [
                    swiper_esm/* FreeMode */.Rv,
                    swiper_esm/* Navigation */.W_,
                    swiper_esm/* Thumbs */.o3
                ],
                className: "swiper-thumbnails-row",
                children: data.map(function(img) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* NextImage */.oH, {
                            src: img.url,
                            alt: img.alt,
                            layout: "fill",
                            placeholder: "blur"
                        })
                    }, img.alt);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
;// CONCATENATED MODULE: ./components/PagesComponents/Products/InfoBox.jsx









var InfoBox = function(_param) {
    var matches = _param.matches, props = (0,_object_without_properties/* default */.Z)(_param, [
        "matches"
    ]);
    var locale = (0,router.useRouter)().locale;
    var t = (0,esm/* useTranslation */.$G)([
        "products"
    ]).t;
    var name = props.name, slug = props.slug, density = props.density, mfi = props.mfi, short_description = props.short_description, applications = props.applications, type = props.type;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            matches && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* ProductBrodCramp */.aq, {
                name: name
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                children: name
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                className: "detailsBoxInfo",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsPage_styles/* Details */.PO, {
                        children: t("mfi")
                    }),
                    ":",
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsPage_styles/* Details */.PO, {
                        className: "info",
                        children: mfi
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                className: "detailsBoxInfo",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsPage_styles/* Details */.PO, {
                        children: t("density")
                    }),
                    ":",
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsPage_styles/* Details */.PO, {
                        className: "info",
                        children: density
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                className: "detailsBoxInfo",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsPage_styles/* Details */.PO, {
                        children: t("application")
                    }),
                    ":",
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsPage_styles/* Details */.PO, {
                        className: "info",
                        locale: locale,
                        children: applications === null || applications === void 0 ? void 0 : applications.data.map(function(item) {
                            return item.attributes.application;
                        }).join(", ")
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsPage_styles/* Description */.dk, {
                locale: locale,
                children: short_description
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/products/".concat(type.data.attributes.name.toString().toLowerCase().split(" ").join("-"), "/").concat(slug, "/order"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Layout_styles/* PrimaryButton */.KM, {
                        className: "orderBtn",
                        children: [
                            t("orderBtn"),
                            " "
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductsPage_styles/* Details */.PO, {
                children: [
                    t("only-type"),
                    ":",
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/products?type=".concat(type.data.attributes.name.toString().toLowerCase().split(" ").join("-")),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            children: type.data.attributes.name
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Products_InfoBox = (InfoBox);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tabs/Tabs.js + 8 modules
var Tabs = __webpack_require__(10760);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tab/Tab.js + 1 modules
var Tab = __webpack_require__(40044);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./components/PagesComponents/Products/ProductItemTabs.jsx











function TabPanel(props) {
    var children = props.children, value = props.value, index = props.index, other = (0,_object_without_properties/* default */.Z)(props, [
        "children",
        "value",
        "index"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        role: "tabpanel",
        hidden: value !== index,
        id: "simple-tabpanel-".concat(index),
        "aria-labelledby": "simple-tab-".concat(index)
    }, other), {
        children: value === index && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
            sx: {
                p: 3
            },
            children: children
        })
    }));
}
function a11yProps(index) {
    return {
        id: "simple-tab-".concat(index),
        "aria-controls": "simple-tabpanel-".concat(index)
    };
}
var ProductItemTabs = function(props) {
    var t = (0,esm/* useTranslation */.$G)([
        "products"
    ]).t;
    var description = props.description, methods = props.methods, markets = props.markets, type = props.type, applications = props.applications, downloads = props.downloads;
    var ref = (0,react.useState)(0), value = ref[0], setValue = ref[1];
    var handleChange = function(event, newValue) {
        setValue(newValue);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
        sx: {
            width: "100%",
            mb: "100px"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                sx: {
                    borderBottom: 1,
                    borderColor: "divider"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Tabs/* default */.Z, {
                    value: value,
                    onChange: handleChange,
                    variant: "scrollable",
                    scrollButtons: "auto",
                    "aria-label": "basic tabs example",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab/* default */.Z, (0,_object_spread/* default */.Z)({
                            label: t("tab.description")
                        }, a11yProps(0))),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab/* default */.Z, (0,_object_spread/* default */.Z)({
                            label: t("tab.additional-information")
                        }, a11yProps(1))),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab/* default */.Z, (0,_object_spread/* default */.Z)({
                            label: t("tab.downloads")
                        }, a11yProps(2)))
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabPanel, {
                value: value,
                index: 0,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* PostContent */.C2, {
                    description: description
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabPanel, {
                value: value,
                index: 1,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductsPage_styles/* AdditionalInformation */.r0, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductsPage_styles/* Column */.sg, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                                    className: "title",
                                    children: t("p-method")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    className: "text",
                                    children: methods === null || methods === void 0 ? void 0 : methods.data.map(function(item) {
                                        return item.attributes.method;
                                    }).join(", ")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductsPage_styles/* Column */.sg, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                                    className: "title",
                                    children: t("p-application")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    className: "text",
                                    children: applications === null || applications === void 0 ? void 0 : applications.data.map(function(item) {
                                        return item.attributes.application;
                                    }).join(", ")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductsPage_styles/* Column */.sg, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                                    className: "title",
                                    children: t("p-market")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                                    className: "text",
                                    children: [
                                        " ",
                                        markets === null || markets === void 0 ? void 0 : markets.data.map(function(item) {
                                            return item.attributes.market;
                                        }).join(", ")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductsPage_styles/* Column */.sg, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                                    className: "title",
                                    children: t("p-type")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    className: "text",
                                    children: type.data.attributes.name
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabPanel, {
                value: value,
                index: 2,
                children: (0,_to_consumable_array/* default */.Z)(downloads || []).map(function(item) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductsPage_styles/* DownloadRow */.m6, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                children: item.file_name
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    href: "https://websiteapidev.aryasasol.com" + item.file.data.attributes.url,
                                    download: true,
                                    children: t("downloadBtn")
                                })
                            })
                        ]
                    }, item.id);
                })
            })
        ]
    });
};
/* harmony default export */ var Products_ProductItemTabs = (ProductItemTabs);

;// CONCATENATED MODULE: ./components/PagesComponents/Products/ProductTypeRead.jsx






var ProductTypeRead = function(param) {
    var description = param.description;
    var ref, ref1, ref2, ref3;
    var t = (0,esm/* useTranslation */.$G)([
        "products"
    ]).t;
    var query = (0,router.useRouter)().query;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductsPage_styles/* ProductTypeReadMoreBox */.to, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                className: "title",
                children: query.type.toUpperCase()
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                className: "content",
                children: description
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "products/".concat((query === null || query === void 0 ? void 0 : (ref = query.type) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "hdpe" ? "high-density-polyethylene" : (query === null || query === void 0 ? void 0 : (ref1 = query.type) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === "mdpe" ? "medium-density-polyethylene" : (query === null || query === void 0 ? void 0 : (ref2 = query.type) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === "ldpe" ? "low-density-polyethylene" : (query === null || query === void 0 ? void 0 : (ref3 = query.type) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) === "olefin" && "olefin"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout_styles/* PrimaryButton */.KM, {
                        children: t("readMore")
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Products_ProductTypeRead = (ProductTypeRead);

;// CONCATENATED MODULE: ./components/PagesComponents/Products/index.jsx








/***/ }),

/***/ 10625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RR": function() { return /* binding */ orderProduct; },
/* harmony export */   "Xp": function() { return /* binding */ getProducts; },
/* harmony export */   "Zj": function() { return /* binding */ getFilters; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35559);
/* harmony import */ var _qsStringify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55063);



var getProducts = function(locale, queries) {
    var query = (0,_qsStringify__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        sort: [
            "publishedAt:asc"
        ]
    }, queries));
    return _api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api-productss?locale=".concat(locale, "&").concat(query)).then(function(res) {
        return res.data;
    });
};
var orderProduct = function(body) {
    return _api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api-product-orders", body).then(function(res) {
        return res.data;
    });
};
var getFilters = function(endpoint, locale) {
    return _api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(endpoint, "?locale=").concat(locale, "&populate=products")).then(function(res) {
        return res.data;
    });
};


/***/ })

}]);